import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-vue', 'BrandVue', [["path",{"d":"M16.5 4l-4.5 8l-4.5 -8"}],["path",{"d":"M3 4l9 16l9 -16"}]]);